import React from 'react';
import Form from '../card/form';

const LoginKontent = () => {
    return (
        <div>
             <h5>Pleas login</h5>
             <p>Walcome to Job elit. Quo amet quia rem id aliquam rerum, obcaecati est eos s</p>
            <Form/>
        </div>
    );
}

export default LoginKontent;
